import { apiUrls } from 'consts'
import { useEffect } from 'react'
import loadRecord from './../utils/loadRecord'

interface useInitProps {
  getValues: Function
  id: string | undefined
  reset: Function
  setDataLoaded: Function
  setShowOverlay: Function
  setIsTrolleyUser: Function
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    if (props.id !== undefined) {
      loadRecord(apiUrls.users, props.id).then((data) => {
        props.setIsTrolleyUser(data.is_trolley_user)
        props.reset(data)
        props.setDataLoaded(true)
        props.setShowOverlay(false)
      })
    }
  }, [])
}

export default useInit
